export enum CaseFlagFilterOptions {
    None = 1,
    DeletedCaseFlags = 2
}